<template>
  <div id="paginador" class="w3-center w3-display-container">
    <div class="w3-bar w3-round pages">
      <div v-show="this.page.pagesNumber > 1" class="paginator-controls">
        <span :class="['w3-bar-item', 'w3-button', 'movePage', {'disabled':(page.number === 1)}]" @click="previousPage($event)">
          <i class="fa fa-caret-left"></i>
        </span>
        <input :class="['w3-bar-item', 'w3-button', 'w3-input', 'pageNumber']" type="text" v-model="fieldNumber" @blur="refreshPageNumber($event)" @keyup="getSearcherPage($event)">
        <span :class="['w3-bar-item', 'totalPages']"> / {{ page.pagesNumber | num }}</span>
        <span :class="['w3-bar-item', 'w3-button', 'movePage', {'disabled' : (page.number === page.pagesNumber)}]" @click="nextPage($event)">
          <i class="fa fa-caret-right"></i>
        </span>
      </div>
      <span :class="['w3-bar-item', 'results']">
        {{ page.totalRows | num }} {{$ml.get('results')}}
      </span>
    </div>
  </div>
</template>

<script>
import prettify from '@/utils/prettify'

export default {
  name: 'searcher-paginator',
  props: [
    'page'
  ],
  data () {
    return {
      fieldNumber: this.page.number
    }
  },
  methods: {
    previousPage (event) {
      if (this.fieldNumber > 1) {
        this.fieldNumber = this.fieldNumber - 1
        this.page.number = this.fieldNumber
        this.refreshPage()
      }
    },
    nextPage (event) {
      if (this.fieldNumber < this.page.pagesNumber) {
        this.fieldNumber = this.fieldNumber + 1
        this.page.number = this.fieldNumber
        this.refreshPage()
      }
    },
    refreshPageNumber (event) {
      if (this.checkPageNumber()) {
        this.refreshPage()
      }
    },
    getSearcherPage (event) {
      if (event.key === 'Enter') {
        if (this.checkPageNumber()) {
          this.refreshPage()
        }
      } else {
        if (this.fieldNumber.trim() !== '' && !this.isNormalInteger(this.fieldNumber, this.page.pagesNumber)) {
          this.fieldNumber = this.page.number
        }
      }
    },
    refreshPage () {
      this.$emit('refreshPage', this.page.number)
    },
    checkPageNumber () {
      var result = false
      if (this.fieldNumber < 1) {
        this.fieldNumber = 1
      } else if (this.fieldNumber > this.page.pagesNumber) {
        this.fieldNumber = this.page.pagesNumber
      }
      if (this.page.number !== this.fieldNumber) {
        this.page.number = this.fieldNumber
        result = true
      }
      return result
    },
    isNormalInteger (str, max) {
      var n = Math.floor(Number(str))
      var nMax = Math.floor(Number(max))
      return n !== Infinity && String(n) === str && n > 0 && n <= nMax
    }
  },
  filters: {
    num (num) {
      return prettify.methods.num(num)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  #paginador {
    border-top: 1px solid #e4e4e4;

    .pages {
      background-color: #efefef;
      margin-top: 10px;
      padding: 3px 3px 2px;
      font-size: 11px;
    }
    .totalPages {
      margin-top: 2px;
      font-size: 0.9em;
      color: #777;
      padding-right: 0;
    }
    .pageNumber {
      padding: 8px 0 7px;
      width: 52px;
      border-radius: 3px;
      background-color: #fff;
      cursor: text;
      transition: all 0.2s ease-in;
    }
    .movePage {
      transition: all 0.2s ease-in;
    }
    .movePage:hover{
      color: #ffbd42 !important;
      background-color: #efefef !important;
    }
    .movePage.disabled,
    .movePage.disabled:hover{
      color: #cccccc !important;
      background-color: #efefef !important;
      cursor: default;
    }
    .paginator-controls {
      float: left;
    }
    .results {
      font-style: italic;
    }
    .w3-button.disabled {
      color: #ccc;
    }
    .w3-display-topright {
      top: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/content/searcher/paginator.vue